import React from 'react';
import Link from 'next/link';
import styles from '@/ui/header-navigation/MegaMenu.module.scss';

const DropdownContent = ({
                             submenuscontent,
                             setIsDrawerOpen,
                             handleClick,
                         }) => {

    return (
        <div className={styles.dropdownContent}>
            {submenuscontent.map((item, index) => (
                <React.Fragment key={index}>
                    <section>
                        <h4>
                            <Link
                                href={item.headingUrl || item.href}
                                onClick={() => {
                                    setIsDrawerOpen(false);
                                }}
                            >
                                {item.heading}
                            </Link>
                        </h4>
                        <ul>
                            {item.submenu?.map(({label, href}, index) => (
                                <li
                                    key={index}
                                    onClick={() => {
                                        setIsDrawerOpen && setIsDrawerOpen(false);
                                        handleClick();
                                    }}
                                >
                                    <Link href={href}>{label}</Link>
                                </li>
                            ))}
                        </ul>
                    </section>
                </React.Fragment>
            ))}
        </div>
    );
};

export default DropdownContent;
